export class StatoInserimento {
  mandatoryNotCompiled: number;
  assegnazionePerSmistamento: boolean;
  assegnazionePerCompetenza: boolean;
  legali: boolean;
}
